import { Grid, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import { getWarehouses } from './redux/stockSelectors';
import WarehouseSelector from './WarehouseSelector';
const mapStateToProps = (state: RootState) => ({
    warehouses: getWarehouses(state)
});

type OwnProps = {
    selectedDate: Date | null;
    selectedWarehouse: number | null;
    setSelectedWarehouseAndDate: (date: Date | null, warehouse: number | null) => void;
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const StockPicker = ({ selectedDate, selectedWarehouse, setSelectedWarehouseAndDate }: Props) => {
    const handleSetDate = (newDate: Date | null) => {
        setSelectedWarehouseAndDate(newDate, selectedWarehouse);
    };

    const handleSetWarehouse = (value: unknown) => {
        setSelectedWarehouseAndDate(selectedDate, value as number);
    };

    return (
        <Grid container direction="row">
            <Grid item>
                <WarehouseSelector
                    selectedWarehouse={selectedWarehouse}
                    onSetWarehouse={handleSetWarehouse}
                />
            </Grid>
            <Grid item>
                <DatePicker
                    inputFormat="yyyy-MM-dd"
                    label="Warehouse date"
                    value={selectedDate}
                    onChange={value => handleSetDate(value)}
                    // sx={theme => ({ marginTop: theme.spacing(1), width: 150 })}
                    renderInput={params => (
                        <TextField
                            {...params}
                            variant="standard"
                            sx={theme => ({ marginTop: theme.spacing(1), width: 150 })}
                        />
                    )}
                />
            </Grid>
        </Grid>
    );
};

export default connect(mapStateToProps)(StockPicker);
